import {
    SAVE_ACTIVITY,
    PENDING_ACTIVITY,
    MARK_ATTENDANCE,
    ACCOUNT_LIST, ACCOUNT_BY_LEAD_ID
} from "./type";

const initialState = {
    // saveAccountDetails:[],
    accountListDetails:[],
    // accountById:[],
    saveActivityRes:[],
    // accountFilterContent:[],
    pendingActivity:[],
    attendance:[],
    accountLeadId:[]
};

const BA = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        // case SAVE:
        //     return {
        //         ...state,
        //         saveAccountDetails: payload,
        //     };
        case ACCOUNT_LIST:
            return {
                ...state,
                accountListDetails: payload,
            };
        // case ACCOUNT_BY_ID:
        //     return {
        //         ...state,
        //         accountById: payload,
        //     };
        case SAVE_ACTIVITY:
            return {
                ...state,
                saveActivityRes: payload,
            };
        // case ACCOUNT_FILTER:
        //     return {
        //         ...state,
        //         accountFilterContent: payload,
        //     };
        case PENDING_ACTIVITY:
            return {
                ...state,
                pendingActivity: payload,
            };
        case MARK_ATTENDANCE:
            return {
                ...state,
                attendance: payload,
            };
        case ACCOUNT_BY_LEAD_ID:
            return {
                ...state,
                accountLeadId: payload,
            };
        default:
            return {...state};
    }
};

export default BA;